import { type ReactElement } from 'react'
import { isNotEmpty } from '@terros/common'
import { createFileRoute } from '@tanstack/react-router'
import { Text } from '@mantine/core'
import { SizePrimitives } from '@front/model'
import { HeroImage, MaterialSymbolIcon, Page, TAlert } from '@components'
import { ProgramHeading } from '../program_.$programId/ProgramHeader'
import { useProgramContext } from '../program_.$programId/context'
import { ProgramPageContainer } from '../program/ProgramPageContainer'
import { ExistingTasks } from './ExistingTasks'
import { AddTaskButton } from './AddTaskButton'

function ProgramTasksPage(): ReactElement {
  const { program } = useProgramContext()
  const hasTasks = isNotEmpty(program.tasks)
  return (
    <ProgramPageContainer>
      <ProgramHeading title='Tasks'>{hasTasks && <AddTaskButton urlKey='add-task' />}</ProgramHeading>
      <Page.Content scrollArea>
        <TAlert title='Changes made to tasks on the program will not affect existing tasks for users in the program, all task changes will only be applied going forward.' />
        {hasTasks ? <ExistingTasks /> : <NoTasks />}
      </Page.Content>
    </ProgramPageContainer>
  )
}

const NoTasks = (): ReactElement => {
  return (
    <HeroImage>
      <MaterialSymbolIcon icon='content_paste' size={SizePrimitives['12']} />
      <Text size='lg'>No Tasks added</Text>
      <AddTaskButton urlKey='add-first-task' />
    </HeroImage>
  )
}

export const Route = createFileRoute('/program_/$programId/tasks/')({
  component: ProgramTasksPage,
})
